export const uppercaseParser = (value?: string) => {
  return value?.toUpperCase() || '';
};
